import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  deviceFilters: {
    assemblyStatus: null,
    calibrationStatus: null,
    packagingStatus: null,
    startDate: null,
    endDate: null,
    //deviceType is deprecated filter, it will be deleted when new dashboard is released
    deviceType: null,
    deviceTypes: null,
    workOrders: null,
    searchExpression: null,
    deviceSerialNumberList: null,
  },
  assemblyFilters: {
    assemblyStatus: null,
    oadUpdateStatus: null,
    startDate: null,
    endDate: null,
    pcbaTypes: null,
    workOrders: null,
    searchExpression: null,
  },
  workOrderFilters: {
    startDate: null,
    endDate: null,
    productType: null
  }
};

const filtersSlice = createSlice({
  name: "pagination",
  initialState: initialState,
  reducers: {
    setDeviceFilters: (state, action) => {
      state.deviceFilters = action.payload;
    },
    setAssemblyFilters: (state, action) => {
      state.assemblyFilters = action.payload;
    },
    clearDeviceFilters: (state, action) => {
      state.deviceFilters = {
        assemblyStatus: null,
        calibrationStatus: null,
        packagingStatus: null,
        startDate: null,
        endDate: null,
        workOrders: null,
        //deviceType is deprecated filter, it will be deleted when new dashboard is released
        deviceType: null,
        deviceTypes: null,
        searchExpression: null,
        deviceSerialNumberList: null,
      };
    },
    setDeviceFilter: (state, action) => {
      const { key, value } = action.payload;
      state.deviceFilters[key] = value;
    },
    setAssemblyFilter: (state, action) => {
      const { key, value } = action.payload;
      state.assemblyFilters[key] = value;
    },
    clearAssemblyFilters: (state, action) => {
      state.assemblyFilters = {
        assemblyStatus: null,
        oadUpdateStatus: null,
        startDate: null,
        endDate: null,
        pcbaTypes: null,
        workOrders: null,
        searchExpression: null,
      };
    },
    setWorkOrderFilters: (state, action) => {
      state.workOrderFilters = action.payload;
    }
  },
});

export const {
  setDeviceFilter,
  setDeviceFilters,
  setAssemblyFilter,
  setAssemblyFilters,
  clearAssemblyFilters,
  clearDeviceFilters,
  setWorkOrderFilters
} = filtersSlice.actions;
export default filtersSlice.reducer;
